import React from 'react';
import PropTypes from 'prop-types';
import BookingStep from './BookingStep';
import Translate from './Translate';
import TextInput from './formComponents/TextInput';
import TextArea from './formComponents/TextArea';
import RadioButtonInput from './formComponents/RadioButtonInput';
import TravelAgencyOptionsHOC from '../hoc/TravelAgencyOptionsHOC';
import {BOOKING, OPTION} from '../constants/TravelAgencyTypes';
import {getCompanyNameByCode} from '../api/utils';

// @todo The false statements on the user id field should be removed when voucher is ready (@EC-34)

const TravelAgencyOptions = props => (
  <section className="booking-step booking-travel-agency-options card" id="booking-travel-agency-options">
    <div className="booking-step__inner">
      <div className="booking-step__inner2">
        <h2 className="card__header">
          <span className="card__header-prefix">
            {props.stepIndex}
            /
            {props.stepTotal}
          </span>
          <Translate content="Travel Agency Options" />
        </h2>
        <section className="card__body" id="TravelAgencyOptions">

          <div className="form-field">
            <label className="form-label">
              <Translate content="Type of booking" />
            </label>
            <div className="group two-col">
              <div className="form-radio">
                <RadioButtonInput
                  checked={props.order.type === BOOKING}
                  id="agency-booking-type-booking"
                  name="agency-booking-type"
                  onChange={props.onTypeChange}
                  value={BOOKING}
                />
                <label htmlFor="agency-booking-type-booking">
                  <Translate content="booking" />
                </label>
              </div>
              <div className="form-radio">
                <RadioButtonInput
                  checked={props.order.type === OPTION}
                  id="agency-booking-type-option"
                  name="agency-booking-type"
                  onChange={props.onTypeChange}
                  value={OPTION}
                />
                <label htmlFor="agency-booking-type-option">
                  <Translate content="option" />
                </label>
              </div>
            </div>
          </div>
          { false && (
            <div className="form-field">
              <label
                className="form-label"
                htmlFor="agency-user-id"
              >
                <Translate content="User ID" />
              </label>
              <TextInput
                className="text-input"
                id="agency-user-id"
                name="agencyUserId"
                onChange={props.onUserIdChange}
                value={props.order.agency.userId}
              />
            </div>
          )}

          <div className="form-field">
            <label
              className="form-label"
              htmlFor="agency-message"
            >
              <Translate
                args={{ '!brand_name': getCompanyNameByCode(props.order.company)}}
                content="Message for !brand_name"
              />
            </label>
            <TextArea
              autoheight
              className="text-area"
              id="agency-message"
              name="agencyMessage"
              onChange={props.onMessageChange}
              value={props.order.agency.message}
            />
          </div>

        </section>
      </div>
    </div>
  </section>
);

TravelAgencyOptions.propTypes = {
  onMessageChange: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  onUserIdChange: PropTypes.func.isRequired,
  order: PropTypes.shape({
    agency: PropTypes.shape({
      message: PropTypes.string.isRequired,
      userId: PropTypes.string.isRequired,
    }).isRequired,
    type: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
  }).isRequired,
  stepIndex: PropTypes.number.isRequired,
  stepTotal: PropTypes.number.isRequired,
};

export default TravelAgencyOptionsHOC(BookingStep(TravelAgencyOptions));